export default __webpack_public_path__ + "static/media/FCSI - ISO 37001_2016 Cert. nr.  IT345302 exp. 26.08.2028 EN.4834e70d.pdf";